import { render, staticRenderFns } from "./ItemComponent.vue?vue&type=template&id=896ac3a0&scoped=true&"
import script from "./ItemComponent.vue?vue&type=script&lang=js&"
export * from "./ItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./ItemComponent.vue?vue&type=style&index=0&id=896ac3a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896ac3a0",
  null
  
)

export default component.exports